// move layerpicker-tool-region above toolbar-region to place the layer selection tool on the map
let t = () => `
<div class="app-block map-region"></div>
<div class="app-block toolbar-region"></div>
<div class="app-block filter-region"></div>
<div class="app-block move-region-block map-legend-region"></div>
<div class="app-block move-region-block map-legend2-region"></div>
<div class="app-block map-bottom-left-region"></div>
`;

export = t;